import Vue from 'src/views/base'
import { Component } from 'vue-property-decorator'
import template from './layout.vue'
import { Store as CommonStore } from 'store/modules/common'

@Component({
    name: 'layout',
    mixins: [template],
    components: {
    },
    provide() {
        return {
            config: this.config.api,
            sidebar: {
                sysName: '账户中心'
            }
        }
    }
})
export default class Layout extends Vue {
    @CommonStore.getter('sidebar') sidebar

    defaultActive = ''
    headerInfo = {
        unReaded: 0,
        unTreated: 0
    }

    created() {
    }

    /**
     * 进入系统时校验组织是否存在
     *
     * @returns
     * @memberof Layout
     */
    async handleBeforeActive() {
        let data = await this.api.commonApi.checkOrganization().then(() => {
            return true
        }).catch(() => {
            return false
        })
        return data
    }
}



// WEBPACK FOOTER //
// ./src/views/components/layout/index.js